import React, { useEffect } from "react";

const ComplianceMapping = () => {
  useEffect(() => {
    window.open("https://govcompliance-dashboard.web.app/", "_blank");
  }, []);

  return null; // no UI needed
};

export default ComplianceMapping;
